import { ZodType, z } from 'zod';

export type GetResultResponse = {
	roundId: string;
	status: string;
	totalBet: number;
	totalWin: number;
	currency: string;
	mines: number[][];
	turnHistory: number[];
	mults: number[];
};

export const getResultResponseSchema: ZodType<GetResultResponse> = z.object({
	roundId: z.string(),
	status: z.string(),
	totalBet: z.number(),
	totalWin: z.number(),
	currency: z.string(),
	mines: z.array(z.array(z.number())),
	turnHistory: z.array(z.number()),
	mults: z.array(z.number()),
});
